import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_PROMPT_CODES_LIST_API = `${API_URL}/api/PatientMasterPromptCodes/GetPatientActivePromptCodes`;
export const GET_PROMPT_CODES_LIST_TO_COLLECTDATA_API = `${API_URL}/api/PatientMasterPromptCodes/GetPatientActivePromptCodesToCollectData`;
export const GET_PROMPT_CODES_LIST_FORSETUP_API = `${API_URL}/api/PatientMasterPromptCodes/GetPatientActivePromptCodesForSetUp`;
export const POST_PROMPT_CODES_API = `${API_URL}/api/PatientMasterPromptCodes/SavePatientMasterPromptCode`;
export const GET_PROMPT_CODES_DETAIL_API = `${API_URL}/api/PatientMasterPromptCodes/GetPatientMasterPromptCodeById`;
export const DELETE_PROMPT_CODES_API = `${API_URL}/api/PatientMasterPromptCodes/DeletePatientMasterPromptCode`;

export const propmtCodesActionTypes = {
  get_masterData: createRequestActionTypes('GET_PATIENT_PROMPT_CODES_MASTER_DATA'),
  save_propmtCodes: createRequestActionTypes('SAVE_PATIENT_PROMPT_CODES'),
  get_propmtCodesList: createRequestActionTypes('GET_PATIENT_PROMPT_CODESLIST'),
  get_propmtCodesDetail: createRequestActionTypes('GET_PATIENT_PROMPT_CODESDETAIL'),
  delete_propmtCodes: createRequestActionTypes('DELETE_PATIENT_PROMPT_CODES'),
};

export const MODULE = 'DCMASTER_PROMPTCODES';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/promptCodes/constants/ApiConstants.js